export const GOOGLE_SHEETS_URL_PATTERN = /docs\.google\.com\/spreadsheets\/d\/[\w-]+/;
export const SERVICE_ACCOUNT_EMAIL =
  "internal-backend-service-accou@employer-brand-index-259614.iam.gserviceaccount.com";
// Platform types that can be uploaded from a Google Sheet link instead of a file
export const LINK_PLATFORM_TYPES = ["Manual Collection China"];
